import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { UserAuthService } from '../services/user-auth.service';
import { take } from 'rxjs';
import { SharedService } from '../services/shared.service';
@Directive({
  selector: '[accessControl]',
  standalone: false,
})
export class AccessControlDirective implements OnInit {
  @Input('userRole') userRole: any;
  @Input('displayStyle') displayStyle?: any;
  hasInformation: boolean = false;
  hasCache: any;
  userInfo: any;

  constructor(
    private elementRef: ElementRef,
    private authService: UserAuthService,
    private sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.elementRef.nativeElement.style.display = 'none';
    this.checkAccess();
    this.authService.counter = 0;
  }

  checkAccess() {
    this.authService
      .getCache()
      .pipe(take(1))
      .subscribe({
        next: (data) => (
          this.authService.setUser(data.value),
          this.setRoles(data.value)
        ),
        error: (err) => (
          this.getUserInfo(),
          console.log(err, 'Error loading roles!')
        ),
      });
    this.authService.roleCount++;
  }

  getUserInfo() {
    this.authService
      .getUserRoles()
      .pipe(take(1))
      .subscribe({
        next: (data) => (
          this.authService.setUser(data),
          this.setRoles(data),
          this.authService
            .setUserSelection(data)
            .pipe(take(1))
            .subscribe({
              next: (data) => console.log(data),
              error: (err) => console.log(err, 'Error setting information!'),
            })
        ),
        error: (err) => console.log(err, 'Error loading!'),
      });
  }

  setRoles(roles: any) {
    setTimeout(() => {
      this.authService.setUser(roles);

      if (roles) {
        const currentRole = [roles.role];
        const role: any = currentRole.some((role: string) =>
          this.userRole.includes(role),
        );
        if (this.displayStyle === 'block') {
          this.elementRef.nativeElement.style.display = role ? 'block' : 'none';
        } else {
          this.elementRef.nativeElement.style.display = role
            ? 'inline-flex'
            : 'none';
        }
      }
    }, 1000);
  }
}
